export default __webpack_public_path__ + "static/media/utilities.88db37e5.svg";